var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_fund_name(),
          value: "" + _vm.tx.counterparty,
          copiable: true
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_base_asset(),
          value: _vm.formatTokenDisplay(_vm.tx.baseAsset)
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_amount(),
          value:
            _vm.i18n.c(_vm.tx.amount) +
            " " +
            _vm.formatTokenDisplay(_vm.tx.asset)
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_fee_paid(),
          value:
            _vm.i18n.c(_vm.tx.feePaid) +
            " " +
            _vm.formatTokenDisplay(_vm.tx.asset)
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_price(),
          value: _vm.i18n.c(_vm.tx.price) + " " + _vm.tx.quoteAsset
        }
      }),
      _vm._v(" "),
      _c("detail", { attrs: { prop: _vm.i18n.lbl_date(), value: _vm.tx.date } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d7f48f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d7f48f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/history/index/components/Details.Match.vue
// module id = pmxV
// module chunks = 1